import {pick} from 'lodash'
import {convertToRichTextFormat} from 'powtoon-commons/richText/utils'
const textItemFields = [
  'text', 'colors',
  'fontSize', 'fontStyle', 'fontWeight',
  'textAlign', 'textDecoration', 'fontName'
]

export default function text(libraryItem) {
  const textItem = pick(libraryItem, textItemFields)
  const richText = convertToRichTextFormat(textItem)
  return {
    ...textItem,
    richText
  }
}